module.exports = __webpack_public_path__ + "img/proveedores.46e4518c.svg";